import { fetchGeneralData } from '../fetchData'
import { ApiSubUrls, Apis } from '../../enums/api-constants'

export const fetchSalesHourly = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
